import assert from 'assert';
import { User } from 'firebase/auth';

export function getUserDisplayName(user: User): string {
    const displayName = user.displayName ?? user.email;
    assert(displayName, 'User is expected to have a display name or email.');
    return displayName;
}
